var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lead-view",attrs:{"id":"admin-lead-kanban-view"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"md":"12"}},[_c('contacts-list-to-assign')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }